import React from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import { ArrowClockwise } from 'react-bootstrap-icons'
import useViewport from '../../../hooks/use-viewport'
import Toggle from 'react-toggle'

const SeriesToggle = ({
    value,
    onChange = () => {},
    visible
}) => {
    const { breakpoint, breakpoints } = useViewport()
    if (!visible) {
        return null
    }
    return (
        <Form.Group as={Row}>
            <Form.Label column sm={12} md={1} lg={2} xl={3}>
                <ArrowClockwise size={30} /> {breakpoint >= breakpoints.XL || breakpoint <= breakpoints.SM ? 'Series' : ''}
            </Form.Label>
            <Col sm={12} md={11} lg={10} xl={3} style={{ display: 'flex', justifyContent: 'row', alignContent: 'center', alignItems: 'center'}}>
                <Toggle
                    checked={Boolean(value)}
                    onChange={e => onChange(e.target.checked)}
                    icons={false}
                />
            </Col>
        </Form.Group>
    )
}

export default SeriesToggle
